<template>
  <svg
    width="166"
    height="113"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 166 113"
    transform="translate(-30)"
  >
    <path
      d="M61 112V52l52 29.714L165 52v60H61zM93.5 79L61 111.5M132 79l32.5 32.5M61 51l16-16M165 51l-16-16M25 74h24M1 89h48"
      stroke="#1B1B1B"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M149 60V1H78v59"
      stroke="#1B1B1B"
      stroke-width="2"
      stroke-linecap="round"
    />
    <circle cx="113.5" cy="34.5" r="19.5" :fill="fill" />
    <path
      d="M104 35.72l7.744 7.28L124 27"
      stroke="#fff"
      stroke-width="4"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      default: "#51B44F",
    },
  },
};
</script>
